import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowRight } = FiIcons;

function AboutSection() {
  return (
    <section className="about-section" id="about">
      <div className="about-image">
        <img
          src="https://images.unsplash.com/photo-1551632436-cbf8dd35adfa?auto=format&fit=crop&w=1000&q=85"
          alt="An elegant Parisian interior"
        />
        <span>Paris, always</span>
      </div>
      <div className="about-copy">
        <span className="eyebrow">The Roommates</span>
        <p className="script-kicker">It began with two women and one Paris apartment</p>
        <h2>Audrey had the little black dress. Capucine had a second act.</h2>
        <p>Girl In Paris imagines the friendship that might have existed between two icons—and the conversations women have when the public performance is over.</p>
        <p>Capucine is our patron saint of reinvention: composed but never untouched, elegant because she has survived, and always willing to make room at the table.</p>
        <div className="about-values">
          <span>Literary</span><span>Resilient</span><span>Warm</span><span>Unfinished</span>
        </div>
        <button className="text-link">
          Discover Brand Like A Girl <SafeIcon icon={FiArrowRight} />
        </button>
      </div>
    </section>
  );
}

export default AboutSection;